export const formatNumBonos = ( value ) => {
  const cleanValue = value.replace(/^(?!0$)0|[^0-9]/g, '');


  return cleanValue;
}